export const NotificationChannels = ["email", "push", "sms", "whatsapp"] as const;
export type NotificationChannel = typeof NotificationChannels[number];

export const NotificationTopics = ["blog", "campaign", "donation", "newsletter", "survey", "volunteer", "other"] as const;
export type NotificationTopic = typeof NotificationTopics[number];

// Subsets of NotificationChannel/NotificationTopic that are actually surfaced to end users (e.g. preference screens).
// `satisfies` guarantees every entry stays a valid NotificationChannel/NotificationTopic while preserving the narrowed literal union.
export const ActiveNotificationChannels = ["email", "sms", "whatsapp"] as const satisfies readonly NotificationChannel[];
export type ActiveNotificationChannel = typeof ActiveNotificationChannels[number];

export const ActiveNotificationTopics = ["blog", "campaign", "donation", "newsletter", "volunteer"] as const satisfies readonly NotificationTopic[];
export type ActiveNotificationTopic = typeof ActiveNotificationTopics[number];

export type NotificationDeliveryOutcome = "success" | "failure";
export type NotificationDeliveryStatus = "pending" | "accepted" | "sent" | "delivered" | "read" | "failed";
export type NotificationEventType = "donation.video_uploaded" | "donation.completed";

export interface Notification {
  id: string;

  dedupeKey: string;
  donationId: string;
  
  eventType: NotificationEventType;
  channel: NotificationChannel;

  recipientPhoneE164: string;

  templateKey: string;
  templateVariables?: Record<string, any>;

  providerMessageId?: string;

  status: NotificationDeliveryStatus;
  attemptCount: number;

  lastError?: string;

  // Set once the dispatch has actually been handed off to Cloud Tasks. Absence of this field
  // (while status is still "pending") is what the reconciliation sweeper looks for.
  enqueuedAt?: Date;
  expiresAt: Date;

  createdAt: Date;
  updatedAt: Date;
}

export interface NotificationDeliveryAttempt {
  id: string;
  
  providerMessageId?: string;
  outcome?: NotificationDeliveryOutcome;

  attemptNumber: number;
  cloudTaskRetryCount?: number;
  
  errorMessage?: string;
  isPermanentFailure?: boolean;

  startedAt: Date;
  finishedAt?: Date;
}

export interface NotificationDetails {
  notification: Notification;
  attempts: NotificationDeliveryAttempt[];
}